<template>
<section class="team">
  <div class="container">
    <h3>Команда</h3>
    <div class="row">
      <div class="col-3">
        <div class="col-img">
          <picture>
            <source srcset="../../public/static/images/team/8.webp">
            <img src="../../public/static/images/team/8.jpg" alt="">
          </picture>
        </div>
        <div class="col-text">
          <p class="name">
            Lorem ipsum
          </p>
          <small>
            Арт-директор GID
          </small>
        </div>
      </div>
      <div class="col-3">
        <div class="col-img">
          <picture>
            <source srcset="../../public/static/images/team/9.webp">
            <img src="../../public/static/images/team/9.jpg" alt="">
          </picture>
        </div>
        <div class="col-text">
          <p class="name">
            Lorem ipsum
          </p>
          <small>
            Арт-директор GID
          </small>
        </div>
      </div>
      <div class="col-3">
        <div class="col-img">
          <picture>
            <source srcset="../../public/static/images/team/10.webp">
            <img src="../../public/static/images/team/10.jpg" alt="">
          </picture>
        </div>
        <div class="col-text">
          <p class="name">
            Lorem ipsum
          </p>
          <small>
            Арт-директор GID
          </small>
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>
export default {
  name: 'SectionTeam',
  components: {},
  methods: {},
  computed: {},
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.team {
  padding: 0 0 45px 0;
  @media (max-width: 997.98px) {
    padding: 0 0 15px 0;
  }
  h3 {
    font-weight: 500;
    font-size: 4rem;
    margin-bottom: 30px;
    @media (max-width: 997.98px) {
      margin-bottom: 10px;
    }
  }
  .row {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -30px;
  }
  .col-3 {
    display: flex;
    flex-direction: column;
    flex: 0 0 33.333%;
    max-width: 33.333%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0 30px;
    position: relative;
    justify-content: space-around;
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      object-position: center;
    }
    .name {
      font-weight: 500;
      font-size: 2.6rem;
      color: #333333;
      margin-top: 20px;
      @media (max-width: 997.98px) {
        margin-top: 10px;
      }
    }
    small {
      font-weight: 300;
      font-size: 1.6rem;
      color: #4F4F4F;
    }
    @media (max-width: 997.98px) {
      flex: 0 0 100%;
      max-width: 100%;
      margin-bottom: 30px;
      img {
        height: 500px;
      }
    }
    @media (max-width: 767.98px) {
      img {
        height: 400px;
      }
    }
    @media (max-width: 576.98px) {
      img {
        height: 300px;
      }
    }
  }
}
</style>
